/**
 * Generated With: pnpm x packages/api/tools/generate-shopify-rest-model.ts https://shopify.dev/api/admin/rest/reference/products/product-image
 * API Version: 2022-01
 */

import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyProductImageKey,
  ShopifyProductImageToProductKey,
  ShopifyProductImageToShopKey,
  ShopifyProductKey,
  ShopifyProductVariantKey,
  ShopifyProductVariantToProductImageKey,
  ShopifyShopKey,
} from "./keys";
import { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyProductImageKey,
  defaultFilterableApiIdentifiers: ["position"],
  "2022-01": {
    name: "Shopify Product Image",
    graphQLTypename: "Image",
    hasMetafields: true,
    fields: [
      {
        name: "Alt",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "alt" } },
      },
      {
        name: "Height",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "height" } },
      },
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "id" } },
      },
      {
        name: "Position",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "position" } },
      },
      {
        name: "Product",
        fieldType: FieldType.BelongsTo,
        key: ShopifyProductImageToProductKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "product_id" } },
        configuration: {
          relatedModelKey: ShopifyProductKey,
        },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "created_at" } },
      },
      {
        name: "Shopify Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "updated_at" } },
      },
      {
        name: "Source",
        fieldType: FieldType.URL,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "src" } },
      },
      {
        name: "Variants",
        key: `${ShopifyProductImageKey}-variants`,
        fieldType: FieldType.HasMany,
        configuration: {
          relatedModelKey: ShopifyProductVariantKey,
          inverseFieldKey: ShopifyProductVariantToProductImageKey,
        },
      },
      {
        name: "Width",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "width" } },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyProductImageToShopKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "shop_id" } },
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: { type: "rest_list", resource: "product" },
  },
  "2024-04": {
    fields: [
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "id", graphQLFieldKey: "id" } },
      },
    ],
    // The GraphQL api for images does not return position, so we can't use it for now
    syncConfig: {
      type: "rest_sublist",
      parent: "products",
      resource: "productImage",
    },
  },
  "2025-01": {
    isDisconnected: true,
  },
  "2025-04": {
    fields: [
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "id",
            graphQLFieldKey: "id",
            availableInWebhook: ["products/create", "products/update"],
          },
        },
      },
      {
        name: "Alt",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "alt", availableInWebhook: ["products/create", "products/update"] },
        },
      },
      {
        name: "Height",
        fieldType: FieldType.Number,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "height", availableInWebhook: ["products/create", "products/update"] },
        },
      },
      {
        name: "Position",
        fieldType: FieldType.Number,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "position", availableInWebhook: ["products/create", "products/update"] },
        },
      },
      {
        name: "Product",
        fieldType: FieldType.BelongsTo,
        key: ShopifyProductImageToProductKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "product_id", availableInWebhook: ["products/create", "products/update"] },
        },
        configuration: {
          relatedModelKey: ShopifyProductKey,
        },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "created_at", availableInWebhook: ["products/create", "products/update"] },
        },
      },
      {
        name: "Shopify Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "updated_at", availableInWebhook: ["products/create", "products/update"] },
        },
      },
      {
        name: "Source",
        fieldType: FieldType.URL,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "src", availableInWebhook: ["products/create", "products/update"] },
        },
      },
      {
        name: "Width",
        fieldType: FieldType.Number,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "width", availableInWebhook: ["products/create", "products/update"] },
        },
      },
    ],
  },
};

export const ShopifyProductImage = ({
  apiVersion,
  frameworkVersionConstraint,
  webhookTopicsForModel,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint?: string;
  webhookTopicsForModel?: string[];
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint, webhookTopicsForModel);
